import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";
import useMyPagePush from "^/customer/myPage/useMyPagePush";
import { useCallback, useId } from "react";

export const Route = createFileRoute("/business/layout/user-teacher-push")({
  component: RouteComponent,
});

function RouteComponent() {
  // const { watch } = useForm<SignUpCustomerState>();
  const { pushInfo, handlePushInfo } = useMyPagePush();
  console.log(pushInfo);
  // const [cookie] = useCookies(["email"]);
  // const email: string = useMemo(() => cookie.email, [cookie]);
  // const ownerOptions = [
  //   { value: "owner1", label: "위탁사업자 이름" },
  //   { value: "owner2", label: "위탁사업자 이름2" },
  // ];
  // console.log(watch());
  // const bindSubmit = (data: SignUpCustomerState) => {
  //   console.log(data);
  //   alert("발송");
  //   // history.push("/business/layout/to-school");
  // };
  return (
    <>
      <LayoutHeader title={"알림"} hasBackBtn hasFootPrint={false} />
      {/* 수신자 */}
      <div className="flex-auto flex flex-col bg-[#F5F5F5]">
        <div className="flex flex-col flex-auto gap-4 px-5 pt-5 rounded-t-3xl">
          <div className="text-[16px] font-semibold">계정 설정</div>
          <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
            <div className="flex justify-between items-center px-4 py-2 w-full">
              <span>알림/공지 푸시 알림</span>
              <ToggleSwitch
                checked={pushInfo.alarmNoticeYn === "Y"}
                onChange={(checked) =>
                  handlePushInfo("alarmNoticeYn", checked ? "Y" : "N")
                }
                // disabled={isUpdating}
              />
            </div>
            <div className="flex justify-between items-center px-4 py-2 w-full">
              <span>마케팅정보 푸시 알림</span>
              <ToggleSwitch
                checked={pushInfo.alarmMarketingYn === "Y"}
                onChange={(checked) =>
                  handlePushInfo("alarmMarketingYn", checked ? "Y" : "N")
                }
                // disabled={isUpdating}
              />
            </div>
            <div className="flex justify-between items-center px-4 py-2 w-full">
              <span>SMS/알림톡 알림</span>
              <ToggleSwitch
                checked={pushInfo.alarmSmsYn === "Y"}
                onChange={(checked) =>
                  handlePushInfo("alarmSmsYn", checked ? "Y" : "N")
                }
                // disabled={isUpdating}
              />
            </div>
            <div className="flex justify-between items-center px-4 py-3 w-full">
              <span>이메일 알림</span>
              <ToggleSwitch
                checked={pushInfo.alarmEmailYn === "Y"}
                onChange={(checked) =>
                  handlePushInfo("alarmEmailYn", checked ? "Y" : "N")
                }
                // disabled={isUpdating}
              />
            </div>
          </div>
          <div className="text-[13px] text-[#666666]">
            알림 설정과 관계 없이 예약 등록/변경/취소 알림 등 필수 알림은
            자동으로 발송됩니다.
          </div>
        </div>
      </div>
    </>
  );
}

const ToggleSwitch = ({
  onChange,
  checked,
  // disabled,
}: {
  onChange: (checked: boolean) => void;
  checked: boolean;
  // disabled: boolean;
}) => {
  const id = useId();

  const handleChange = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);

  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        className="hidden"
        // disabled={disabled}
      />
      <label
        htmlFor={id}
        className={`
          cursor-pointer relative flex items-center
          min-w-[40px] h-3 px-4 rounded-full transition-colors
          ${checked ? "bg-orange-400" : "bg-[#CCCCCC]"}
          border border-gray-300 text-center
        `}
        style={{ minWidth: 50, height: 24 }}
      >
        <span
          className={`
            absolute top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-white shadow transition-all duration-200
            ${checked ? "right-2" : "left-2"}
          `}
          style={{
            left: checked ? "auto" : 2,
            right: checked ? 2 : "auto",
          }}
        />
      </label>
    </div>
  );
};
